module.exports = __webpack_public_path__ + "fonts/SourceCodePro-Black.545c6149.ttf";